import Conditional from '../../Conditional';
import sharedLink from '../../helpers/shared_link.jsx';
import { profileURL } from '../../FindAContractor/profileURL.js';
import withDefaultPrevented from '../../../withDefaultPrevented';
import { ContractorLink, ContractorEmailLink, contractorDataTrack } from "./ContractorLink";
import { connectLocation } from '../../location/LocationConnectors';
import Stars from '../../Stars';
import Text from '../../OC/oc-text';


const contractorDefaultImage = 'https://dp9jl1397yfvp.cloudfront.net/pys/static/images/generic-house.jpg';

const ContractorReview = connectLocation(({ count, stars, t }) => {
  if (!count) {
    return null;
  }

  return <div className="contractor-review">
    <span><Stars stars={stars} /></span>
    <span><Text content={`(${count} ${t('shingles.statics.reviews')})`} /></span>
  </div>;
});

const ContractorCard = ({ contractor, onRequestAQuoteClick, t, locale }) => {
  const ProfileLink = sharedLink({
    href: profileURL(contractor.mas_dealer_code, locale?.code),
    track: ['learn-more', {
      'element-location': 'main section text link',
      'destination': 'Contractor Profile',
      ...contractorDataTrack(contractor)
    }]
  });

  return (<div key={contractor.mas_dealer_code || contractor.store_name} className="contractor-card">
    <ProfileLink>
      <img className="logo" src={contractor.logo || contractorDefaultImage} alt={contractor.store_name} />
    </ProfileLink>
    <div className="info">
      <ProfileLink>
        <h6>{contractor.store_name}</h6>
      </ProfileLink>

      <div className="badges">
        {contractor.is_preferred_platinum && <img src="https://imagecdn.owenscorning.com/ocimages/image/upload/h_40/v1583158599/roofing/badges/platinum-contractor.png" alt="Owens Corning Preferred Platinum" height="20" />}
        {!contractor.is_preferred_platinum && <img src="https://imagecdn.owenscorning.com/ocimages/image/upload/h_40/v1583158599/roofing/badges/preferred-contractor.png" alt="Owens Corning Preferred" height="20" />}

        <ContractorReview count={contractor.gq_review_count} stars={parseFloat(contractor.gq_review_stars)} />
      </div>

      <div className="contact-get-in-touch">
        <ContractorLink
          contractor={contractor}
          href={`tel:${contractor.phone}`}
          text={contractor.phone}
          track="phone" />

        <Conditional if={contractor.has_email}>
          {/** this doesn't work presently. The API doesn't have an email key. See components/FindAContractor/ContractorBlock.jsx#L136  */}
          {' | '}
          <ContractorEmailLink contractor={contractor} />
        </Conditional>

        <Conditional if={contractor.website}>
          {' | '}
          <ContractorLink
            contractor={contractor}
            href={contractor.website}
            text={t('shingles.website')}
            rel="noopener noreferrer"
            track="website"
            target="_blank" />
        </Conditional>

        <Conditional if={contractor.show_request_a_quote}>
          <span className="hidden-xs show-md">{' | '}</span>
          <br className="hidden-md" />
          <ContractorLink
            contractor={contractor}
            href="#"
            text={t('shingles.request_quote')}
            onClick={withDefaultPrevented(() => onRequestAQuoteClick(contractor))}
            className="request-quote"
            track="form-start"
            data-track-form-type="lead"
            data-track-form-name="request-a-quote" />
        </Conditional>
      </div>
    </div>
  </div>);
};

export default ContractorCard
